import Component from './SecurePassword.vue';

export default Component;
